export default __webpack_public_path__ + "static/4-3034df6a253dd826aa066d62677d0cc7.jpg";